import { Workbook } from 'exceljs'
import {
  CitizenCategory,
  PRODUCT_CATEGORIES_INFO,
  PRODUCT_CATEGORIES_REPORTS_UNITS_FULL,
  ProductCategory,
  citizenCategoryShorthand,
} from '@prodcard/core'
import { AdditionalOptsWorksheet } from '../../interfaces'
import { chain, forEach, head, last, map, size } from 'lodash'

export function createSheetActualIssueProducts(workbook: Workbook, sheetName: string, opts: AdditionalOptsWorksheet) {
  const worksheet = workbook.addWorksheet(sheetName)
  worksheet.addRow([
    'Категория граждан',
    'Продовольственная категория',
    ...new Array(size(ProductCategory) - 1),
    opts.tableVariant !== 'actualConsumption' ? 'Итого:' : null,
  ])

  worksheet.addRow([
    '',
    ...map(ProductCategory, pc => {
      if (opts.tableVariant === 'actualConsumption') {
        return `${PRODUCT_CATEGORIES_INFO[pc].shorthand} ${PRODUCT_CATEGORIES_REPORTS_UNITS_FULL[pc] || ''}`
      } else {
        return PRODUCT_CATEGORIES_INFO[pc].shorthand
      }
    }),
    '',
  ])
  worksheet.views = [{ state: 'frozen', ySplit: 2 }]

  const allCellLetters: (string | undefined)[] = worksheet.columns.map(c => c.letter)
  const productCategoryCellLetters: (string | undefined)[] = chain([...allCellLetters])
    .tap(a => {
      a.pop()
    })
    .tap(a => {
      a.shift()
    })
    .value()

  worksheet.mergeCells(`${head(productCategoryCellLetters)}1:${last(productCategoryCellLetters)}1`)
  worksheet.mergeCells(`${head(allCellLetters)}1:${head(allCellLetters)}2`)
  worksheet.mergeCells(`${last(allCellLetters)}1:${last(allCellLetters)}2`)

  opts.actualIssueProducts.forEach(aip => {
    const nameMERow = worksheet.addRow([opts.municipalEntities.find(me => me.id === aip.municipalEntityId)?.name])
    worksheet.mergeCells(`${head(allCellLetters)}${nameMERow.number}:${last(allCellLetters)}${nameMERow.number}`)

    forEach(CitizenCategory, cc => {
      const citizenCategoryRow = worksheet.addRow([
        citizenCategoryShorthand(cc),
        ...map(ProductCategory, pc => aip.values[cc][pc][opts.tableVariant]),
      ])
      if (opts.tableVariant !== 'actualConsumption') {
        worksheet.getCell(`${last(allCellLetters)}${citizenCategoryRow.number}`).value = {
          formula: `SUM(${head(productCategoryCellLetters)}${citizenCategoryRow.number}:${last(
            productCategoryCellLetters,
          )}${citizenCategoryRow.number})`,
        }
      }
    })

    if (opts.tableVariant !== 'actualConsumption') {
      const sumByCitizenCategoryRow = worksheet.addRow(['Итого', ...allCellLetters.slice(1).map(() => '')])
      sumByCitizenCategoryRow.eachCell((cell, number) => {
        if (number > 1) {
          const cellLetter = allCellLetters[number - 1]
          const rowNumber = Number(cell.row)
          cell.value = {
            formula: `SUM(${cellLetter}${rowNumber - size(CitizenCategory)}:${cellLetter}${rowNumber - 1})`,
          }
        }
      })
    }
  })
}
